/**
 * Ninja logo component — renders the ninja head icon.
 * Keeps the same export name (LotusLogo) for backward compat with all imports.
 */
export function LotusLogo({ className = 'h-9 w-9' }: { className?: string }) {
  return (
    <img
      src="/assets/logo/ninja-icon-128.png"
      alt="Your Solution"
      className={className}
    />
  );
}
